<template>
  <div class="file-cust-gid">
    <div v-for="sample in samples" :key="first_file(sample).id">
      <FilePreview :file="first_file(sample)" :set_id="file_set_id(sample)" :image_type="get_img_type(sample)">
        <div>
          <div style="width: 50%; float: left;">
            <i v-if="sample.actions.delete" @click="$emit('sendForDelete', sample.id)"
              class="fa fa-trash fa-danger fa-lg" />
          </div>
          <router-link style="width: 50%; float: left;" v-if="sample.actions.update"
            :to="{ name: 'SampleUpdate', params: { project_id: sample.project_id, sample_set_id: sample.sample_set_id, id: sample.id } }">
            <a><i class="mx-1 fa fa-edit fa-lg" /></a>
          </router-link>
        </div>
      </FilePreview>
    </div>
  </div>
</template>
<script>
import FilePreview from '@/views/Shared/FilePreview.vue';
import FilesPreviewSlider from '@/views/Shared/FilesPreviewSlider.vue';

export default {
  props: {
    samples: {
      value: Array,
      required: true,
    },
  },
  components: {
    FilePreview, FilesPreviewSlider
  },
  methods: {
    first_file(sample) {
      return sample.files.length > 0 ? sample.files[0] : sample.detection_files[0];
    },
    get_files(sample) {
      return sample.files.length > 0 ? sample.files : sample.detection_files;
    },
    file_set_id(sample) {
      return sample.files.length > 0 ? sample.sample_set_id : sample.detection_set_id;
    },
    get_img_type(sample) {
      return sample.files.length > 0 ? 'sample' : 'detection';
    }
  }
};
</script>
